const { funderDocsToEntities } = require('./../../../tools/utils')

exports.list = async function (state, { unfiltered = false, programIds = [] } = {}) {
  const { user: { funders, programs } } = state
  let funderList = []
  if (unfiltered) {
    funderList = await state.dal.funders.listAll(state)
  } else {
    const programList = !programs || !programs.length ? programIds : programs
    funderList = await state.dal.funders.listByPrograms(state, programList)
    if (funderList.length !== 0 && funders && funders.length !== 0) {
      funderList = funderList.filter(funder => funders.includes(funder._id))
    }
  }
  return funderDocsToEntities(funderList)
}
